<ng-http-loader />

<router-outlet />
